import request from "../../../utils/request";

export const getOrderTypes = 'base/getOrderTypes'
export const getCurrencies = 'base/getCurrencies'
export const getDealerGroups = 'base/getDealerGroups'
export const getSalesTaxGroups = 'base/getSalesTaxGroups'
export const getCountries = 'base/getCountries'
export const getSalesAreas = 'base/getSalesAreas'
export const getDealerNatures = 'base/getDealerNatures'
export const getExpresses = 'base/getExpresses'
export const getGroups = 'base/getGroups'

export function editOrderType(values: any) {
    return request.request({
        url: '/base/editOrderType',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editCurrency(values: any) {
    return request.request({
        url: '/base/editCurrency',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editDealerGroup(values: any) {
    return request.request({
        url: '/base/editDealerGroup',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editSalesTaxGroup(values: any) {
    return request.request({
        url: '/base/editSalesTaxGroup',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editCountry(values: any) {
    return request.request({
        url: '/base/editCountry',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editSalesArea(values: any) {
    return request.request({
        url: '/base/editSalesArea',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editDealerNature(values: any) {
    return request.request({
        url: '/base/editDealerNature',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editExpress(values: any) {
    return request.request({
        url: '/base/editExpress',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function editGroup(values: any) {
    return request.request({
        url: '/base/editGroup',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function deleteOrderType(id: number) {
    return request({
        url: '/base/deleteOrderType',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteCurrency(id: number) {
    return request({
        url: '/base/deleteCurrency',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteDealerGroup(id: number) {
    return request({
        url: '/base/deleteDealerGroup',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteSalesTaxGroup(id: number) {
    return request({
        url: '/base/deleteSalesTaxGroup',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteCountry(id: number) {
    return request({
        url: '/base/deleteCountry',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteSalesArea(id: number) {
    return request({
        url: '/base/deleteSalesArea',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteDealerNature(id: number) {
    return request({
        url: '/base/deleteDealerNature',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteExpress(id: number) {
    return request({
        url: '/base/deleteExpress',
        method: 'delete',
        params: {id: id}
    })
}

export function deleteGroup(id: number) {
    return request({
        url: '/base/deleteGroup',
        method: 'delete',
        params: {id: id}
    })
}

export function onSetDefaultExpress(id: number) {
    return request({
        url: "/base/setDefaultExpress",
        method: "get",
        params: {id: id}
    })
}

